import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/network.svg'
import _imports_1 from '@/assets/images/idcard.svg'
import _imports_2 from '@/assets/images/bankcard.svg'


const _hoisted_1 = { class: "id-type" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import * as types from '@/store/modules/common/mutation-type'
import { FormType, OpenType, RouterName } from '@/enum'
import useOpenInfo from '@/hooks/openInfo'
import { setApptitle } from '@/utils/native-app'
import { CustomDialog } from '@/components/CustomDialog'
import * as storage from '@/utils/storage'
import { useMutation, useQuery } from '@vue/apollo-composable'
import { dicCheckIp } from '@/graphql/query'
import { mutateApi } from '@/graphql/mutation'
import { Message } from '@/components/Message'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const actionType = ref()
// 保存步骤信息
const { title } = useOpenInfo()

const mainland = computed(() => OpenType.MAINLAND)
const overseas = computed(() => OpenType.OVERSEAS)
const userInfo = storage.get('userInfo') as any
const formType = computed(() => route.query.type || storage.get('formType'))
// 检查ip是否为大陆地区
const ipCheckCn = ref(false)
const cnOrOther = ref()

const { onResult } = useQuery(dicCheckIp, {
  param: {
    markList: ['CUSTOMER_ACTION_TYPE']
  }
})

onResult((res) => {
  const { findDictOpenAccount, checkIpLocation } = res.data
  if (findDictOpenAccount.ok) {
    actionType.value = findDictOpenAccount.data.CUSTOMER_ACTION_TYPE.filter(
      (item: { mark: string }) => item.mark === 'CUSTOMER_ACTION_TYPE_1'
    )[0]?.value
  } else {
    Message({ direction: 'vertical', text: '请求异常，请稍后重试！(Dict)' })
  }
  if (checkIpLocation.ok) {
    ipCheckCn.value = true
  }
})

const { mutate: operationRecord } = useMutation(mutateApi.clientOperationRecord)
const { mutate: saveDraft, onDone: saveDraftDone } = useMutation(mutateApi.saveClientFormDraft)

saveDraftDone((res) => {
  const { saveClientFormDraft } = res.data
  if (saveClientFormDraft.ok) {
    const info = {
      openType: cnOrOther.value
    }
    store.commit(types.OPEN_COMMON, { info })
    if (formType.value === FormType.OPEN_ACCOUNT) {
      if (cnOrOther.value === OpenType.MAINLAND) {
        router.push({ name: RouterName.MAINLAND_DECLARATION })
      } else {
        router.push({ name: RouterName.ID_CARD })
      }
    }
    if (formType.value === FormType.OPEN_IMMIGRANT_ACCOUNT) {
      router.push({ name: 'account-type' })
    }
  } else {
    Message({ direction: 'vertical', text: '请求异常，请稍后重试！(Draft)' })
  }
})

const handleClick = (type: number) => {
  cnOrOther.value = type
  if (ipCheckCn.value) {
    // IP地址弹窗
    return CustomDialog({
      title: '您当前位于：中国内地',
      confirmText: '我知道了',
      content:
        '非常抱歉，目前无法为中国境内投资者提供开户服务。如有任何疑问，请致电服务热线(852) 2153 3838 或电邮至cs@goldhorse.com.hk与我们查询。'
    })
  }
  if (type === OpenType.MAINLAND) {
    CustomDialog({
      cancelText: '取消',
      content:
        // eslint-disable-next-line max-len, max-len
        '<p style="text-align:left;line-height: 1.5;">鉴于中国证券监督管理委员会、上海证券交易所、深圳证券交易所发布了有关限制内地投资者参与沪深股通交易的规则修订，由2022年7月25日（星期一）起，金马证券<span style="font-weight:800;border-bottom:2px solid #bfc7de">不能</span>再为持有中国内地身份证明文件的内地投资者开通新的⎡券商客户编码⎦（俗称BCAN）。</p><p style="line-height: 1.5;text-align:left;margin-top: 30px;">请注意: 客户买卖北向交易的中华通证券需持有券商客户编码。如有任何疑问, 请致电 (852) 21533838 与我们联系。</p>'
    })
      .then(() => {
        // 记录用户选择
        operationRecord({
          params: {
            tradeAccount: userInfo.clientId,
            fundAccount: userInfo.clientId,
            actionType: actionType.value
          }
        })

        // 记录缓存
        saveDraft({
          params: {
            formType: formType.value,
            meta: 'open_common',
            content: JSON.stringify({ openType: type })
          }
        })
      })
  } else {
    // 记录缓存
    saveDraft({
      params: {
        formType: formType.value,
        meta: 'open_common',
        content: JSON.stringify({ openType: type })
      }
    })
  }
}

onMounted(async () => {
  setApptitle(title)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "id-type-title" }, "请选择开户证件类型", -1)),
      _createElementVNode("div", {
        class: "id-type-card",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick(mainland.value)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", null, [
          _createElementVNode("div", { class: "left" }, [
            _createElementVNode("div", null, "中国内地大陆身份证"),
            _createElementVNode("div", null, [
              _createElementVNode("span", null, "年满18岁"),
              _createElementVNode("span", null, "有效身份证件"),
              _createElementVNode("span", null, "处于香港境内或海外地区")
            ])
          ])
        ], -1)
      ])),
      _createElementVNode("div", {
        class: "id-type-card id-hk",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick(overseas.value)))
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            (formType.value === _unref(FormType).OPEN_IMMIGRANT_ACCOUNT)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "澳台及海外居民证件"))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, "港澳台及海外居民证件")),
            _cache[3] || (_cache[3] = _createElementVNode("div", null, [
              _createElementVNode("span", null, "身份证件"),
              _createElementVNode("span", null, "3个月内住址证明")
            ], -1))
          ])
        ])
      ])
    ]),
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"footer\" data-v-7e6b489f><div class=\"prepare\" data-v-7e6b489f>开户前请准备</div><div class=\"condition\" data-v-7e6b489f><div data-v-7e6b489f><img src=\"" + _imports_0 + "\" class=\"img\" alt=\"\" data-v-7e6b489f><div data-v-7e6b489f>良好网络</div></div><div data-v-7e6b489f><img src=\"" + _imports_1 + "\" class=\"img\" alt=\"\" data-v-7e6b489f><div data-v-7e6b489f>身份证件</div></div><div data-v-7e6b489f><img src=\"" + _imports_2 + "\" class=\"img\" alt=\"\" data-v-7e6b489f><div data-v-7e6b489f>同名银行卡</div></div></div></div>", 1))
  ]))
}
}

})